/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Directive, ElementRef, Injector, Input, OnInit, Renderer2 } from '@angular/core';
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
    MultiLineCustomTooltipComponent,
    TOOLTIP_DATA
} from '../components/multi-line-custom-tooltip/multi-line-custom-tooltip.component';

@Directive({
    selector: '[novaMultiLineTooltip]',
    standalone: true
})
export class MultiLineCustomTooltipDirective implements OnInit {
    @Input('novaMultiLineTooltip') tooltipText: string;
    @Input() tooltipPosition: string;

    overlayRef: OverlayRef;

    constructor(
        private readonly overlay: Overlay,
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2,
        private readonly injector: Injector,
        private readonly overlayPositionBuilder: OverlayPositionBuilder
    ) {}

    ngOnInit() {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-describedby', 'tooltip');

        const positionStrategy = this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef).withPositions([
            {
                originX: 'center',
                originY: 'bottom',
                overlayX: 'center',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.keydownEvents().subscribe((event) => {
            if (event.key === 'Escape') {
                this.overlayRef.detach();
            }
        });

        this.renderer.listen(this.elementRef.nativeElement, 'mouseenter', () => this.show());
        this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', () => this.hide());
    }

    show() {
        const tooltipPortal = new ComponentPortal(
            MultiLineCustomTooltipComponent,
            null,
            this.createInjector(this.tooltipText)
        );
        this.overlayRef.attach(tooltipPortal);
    }

    hide() {
        this.overlayRef.detach();
    }

    createInjector(data: any) {
        return Injector.create({
            providers: [{ provide: TOOLTIP_DATA, useValue: { text: data } }],
            parent: this.injector
        });
    }
}
